<!--
 * @Author: fangzhi fangzhi@vivo.com
 * @Date: 2022-10-18 14:38:59
 * @LastEditors: tianyuhan
 * @LastEditTime: 2023-08-01 18:56:10
 * @FilePath: /h5/src/views/product/detail/components/guarantee/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div v-if="spuInfo && spuInfo.commodityServiceTips && spuInfo.commodityServiceTips.length !== 0">
    <div
      class="guarantee"
      v-track="{
        act: 'show',
        params: {
          cfrom: '180|001|02|077',
          event_id: '180|001|02|077',
          page_name: 1,
          sku_id: skuId,
          is_new: 2
        }
      }"
    >
      <v-list-view name="保障" @click="showGurant" right-icon="arrow-right-v3">
        <div class="content">
          <div class="guarantee-item" v-for="(item, index) in spuInfo.commodityServiceTips" :key="index">
            <img v-lazy="item.serviceIcon" alt="" v-if="item.serviceIcon" />
            <div>{{ item.serviceName }}</div>
          </div>
        </div>
      </v-list-view>
      <v-os-popup
        container="body"
        v-model="isShowPop"
        class="guar"
        :title="title"
        @close="isShowPop = false"
        :footerShow="false"
      >
        <div class="guarantee-pop">
          <text-content v-for="(item, index) in spuInfo.commodityServiceTips" :key="index" :item="item" />
        </div>
      </v-os-popup>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import TextContent from './text-content'

export default {
  name: 'Guarantee',
  components: { TextContent },
  data() {
    return {
      isShowPop: false
    }
  },
  computed: {
    ...mapState('detailv3', ['spuInfo']),
    ...mapGetters('detailv3', ['skuId']),
    title() {
      return this.spuInfo.commoditySpu.proxySale == 1 ? '第三方商品售后保障' : '售后保障'
    }
  },
  methods: {
    ...mapActions('detailv3', ['savePreFocusElByEvent']),
    showGurant(e) {
      this.savePreFocusElByEvent(e)
      this.isShowPop = true
      this.$track({
        cfrom: '180|001|01|077',
        event_id: '180|001|01|077',
        page_name: 1,
        sku_id: this.skuId,
        is_new: 2
      })
    },
    format(val) {
      return val.replace(/\n|\r/g, '<br/>')
    }
  }
}
</script>

<style scoped lang="scss" src="./index.scss" />
<style lang="scss" scoped src="../../index/dark-popup.scss"></style>
